import client from './client';

// 로그인
export const login = ({corprInfoDiviNo, stdYear, userName, ssnNo }) =>
    client.post('/api/login', { corprInfoDiviNo, stdYear, userName, ssnNo });

// 로그인 상태 확인
export const check = () => client.get('/api/auth/check');

// 법인정보 조회
export const getCorprName = ({stdYear, corprInfoDiviNo}) => client.post('/api/getCorprName',{
        stdYear,
        corprInfoDiviNo
});

// 공통코드 조회
export const getCommCode = ({groupCode}) => client.post('/api/getCommCode',{
        groupCode
});